/**
 * Web stand-in for revenueCatPaywall.native.ts — Seven Free Days Wave 6.
 * Web has no store paywall: the provider is always `legacy` there, nothing is
 * presented, and the UI package is never bundled (`expo export --platform web`
 * stays green — N7). Same exports and signatures, inert bodies.
 */
export const PAYWALL_PLACEMENTS = ['day7_stop', 'account_plans'] as const;
export type PaywallPlacement = (typeof PAYWALL_PLACEMENTS)[number];
export const CEDAR_COHORTS = [
  'pre_trial', 'trial_active', 'trial_expired', 'paid_expired', 'paid_active', 'paid_cancelled_grace',
  'billing_issue', 'free_month_active', 'free_month_ended', 'grant', 'unknown',
] as const;
export type CedarCohort = (typeof CEDAR_COHORTS)[number];
export const NO_PURCHASE_SCREEN_COHORTS: readonly CedarCohort[] = ['free_month_active', 'grant'];
export const STORE_BACKED_COHORTS: readonly CedarCohort[] = ['paid_active', 'paid_cancelled_grace', 'billing_issue'];
export type PaywallProvider = 'legacy' | 'revenuecat';
export type PaywallVariables = Partial<Record<
  'headline' | 'first_name' | 'days_used' | 'workouts_completed' | 'goal_title' | 'next_event_date',
  string
>>;
export type RcPaywallOutcome = 'PURCHASED' | 'RESTORED' | 'CANCELLED' | 'ERROR' | 'NOT_PRESENTED';
export interface RcPaywallResult { outcome: RcPaywallOutcome; reason?: 'ui_unavailable' | 'cohort_guard' | 'no_offering' | 'web'; }
export function shouldUseRevenueCatPaywall(
  _provider: PaywallProvider | null | undefined,
  _cedarCohort: CedarCohort | string | null | undefined,
): boolean { return false; }
export function shouldUseCustomerCenter(
  _provider: PaywallProvider | null | undefined,
  _cedarCohort: CedarCohort | string | null | undefined,
): boolean { return false; }
export function mapPaywallResult(raw: unknown): RcPaywallOutcome {
  const s = String(raw ?? '').toUpperCase();
  return (s === 'PURCHASED' || s === 'RESTORED' || s === 'CANCELLED' || s === 'ERROR' || s === 'NOT_PRESENTED') ? s : 'ERROR';
}
export function revenueCatUiAvailable(): boolean { return false; }
export function loadRevenueCatUI(): null { return null; }
export async function presentRevenueCatPaywall(_opts: {
  placement: PaywallPlacement;
  cedarCohort?: CedarCohort | string | null;
  variables?: PaywallVariables | null;
  displayCloseButton?: boolean;
}): Promise<RcPaywallResult> {
  return { outcome: 'NOT_PRESENTED', reason: 'web' };
}
export async function presentRevenueCatCustomerCenter(): Promise<boolean> { return false; }
export async function mirrorCedarCohort(_cedarCohort: string | null | undefined): Promise<void> { /* web: no-op */ }
